import { modelValid } from "../modelSystemG";
import { panelController, getInt } from "./../../stores/service";
import { firebase } from "../../firebase";
import { collection } from "@firebase/firestore";
import { createNewDate } from "../../Controller/APIs/date";
/* 'http://worldtimeapi.org/api/timezone/America/Mexico_City' */

export async function crearUser(user) {
  let currentDate = await createNewDate("America/Mexico_City");
  /* console.log(currentDate); */
  let mesas = new Array(10).fill({
    status: false,
    service: {
      n: 0,
      date: "",
      status: false,
    },
    dataUser: { status: false, displayName: "", photoURL: "" },
    cuenta: {
      n: 0,
      date: "",
      status: false,
    },
  })
  if (currentDate.status) {
    return await modelValid({
      data: {
        collection: "service",
        
        data: {
          name: user.displayName,
          ico:user.photoURL,
          date: `${currentDate.day}-${currentDate.month}-${currentDate.year}`,
          version: 2,
          idServices: `${getInt(9999999999)}`,
          datauser: {
            country: "",
          },
          service: {
            mode: 1,
            sub: false,
            super: false,
            pdfMenu: "",
            membresia: true,
            mesasService: mesas,
          },
          membresia: false /* rol: 0, */ /* admin,nuevo,muestra,login, colaborador ,  */,
          admins: [
            {
              email: user.email,
            },
          ],
          tableadmins: [
            {
              email: user.email,
              name: user.displayName,
              date: `${currentDate.day}-${currentDate.month}-${currentDate.year}`,
              admin: true,
            },
          ],

          listRatinggs: [
            {
              config: {
                firebase: { doc: false },
                idMuestra: getInt(99999999999),
                date: `${currentDate.day}-${currentDate.month}-${currentDate.year}`,
                id: getInt(99999),
                key: [false, 0],
                login: false,
                mode: 1,
                name: "Dinerserv",
              },
              rattings: [
                {
                  pregunta: "¿Que te pareció el servicio?",
                  tipo: 2,
                },
                {
                  pregunta: "¿Que te parecieron los alimentos y bebidas?",
                  tipo: 3,
                },
                {
                  pregunta: "¿Que te pareció la velocidad del servicio?",
                  tipo: 3,
                },
                {
                  pregunta: "¿Te pareció un servicio eficiente?",
                  tipo: 3,
                },
                {
                  pregunta: "¿Tuviste un trato amable?",
                  tipo: 3,
                },
                {
                  pregunta: "¿Que te parecieron las instalaciones?",
                  tipo: 3,
                },
                {
                  pregunta: "¿Tienes algún comentario?",
                  tipo: 4,
                },
              ],
            },
            {
              config: {
                firebase: { doc: false, listindices: { id: "", date: "" } },
                idMuestra: getInt(99999999999),
                date: `${currentDate.day}-${currentDate.month}-${currentDate.year}`,
                id: getInt(99999),
                key: [false, 0],
                login: false,
                mode: 3,
                name: "Tasa de Retención de Clientes (CRR)",
              },
              rattings: [
                {
                  pregunta:
                    "¿Qué tan satisfecho(a) estás con la calidad del servicio que has recibido?",
                  tipo: 1,
                  checkboxOpc: 2,
                  checks: [
                    "Muy insatisfecho(a)",
                    "Insatisfecho(a)",
                    "Neutral",
                    "Satisfecho(a)",
                    "Muy satisfecho(a)",
                  ],
                },
                {
                  pregunta: "¿Con qué frecuencia utilizas nuestro servicio?",
                  tipo: 1,
                  checkboxOpc: 2,
                  checks: [
                    "Diariamente",
                    "Semanalmente",
                    "Mensualmente",
                    "Raramente",
                    "Nunca",
                  ],
                },
                {
                  pregunta:
                    "¿Qué tan probable es que sigas utilizando nuestro servicio en el futuro?",
                  tipo: 1,
                  checkboxOpc: 2,
                  checks: [
                    "Muy improbable",
                    "Improbable",
                    "Neutral",
                    "Probable",
                    "Muy probable",
                  ],
                },
                {
                  pregunta:
                    "¿Qué tan fácil te resulta resolver problemas o dudas con nuestro servicio?",
                  tipo: 1,
                  checkboxOpc: 2,
                  checks: [
                    "Muy difícil",
                    "Difícil",
                    "Neutral",
                    "Fácil",
                    "Muy fácil",
                  ],
                },
                {
                  pregunta:
                    "¿Qué tan satisfecho(a) estás con las actualizaciones y mejoras de nuestro servicio?",
                  tipo: 1,
                  checkboxOpc: 2,
                  checks: [
                    "Muy insatisfecho(a)",
                    "Insatisfecho(a)",
                    "Neutral",
                    "Satisfecho(a)",
                    "Muy satisfecho(a)",
                  ],
                },
                {
                  pregunta:
                    "¿Qué factores te harían considerar dejar de usar nuestro servicio?",
                  tipo: 1,
                  checkboxOpc: 2,
                  checks: [
                    "Precio",
                    "Calidad",
                    "Servicio al cliente",
                    "Alternativas mejores",
                    "Otros (especificar)",
                  ],
                },
                {
                  pregunta:
                    "¿Cómo calificarías tu experiencia general con nuestra empresa?",
                  tipo: 3,
                },
              ],
            },
          ],
        },
      },
      doc: "createDoc",
    });
  } else {
    return { status: false };
  }
}

export async function createMuestras(id) {
  return modelValid({
    data: {
      collection: "muestras",
      data: { idMuestra: id, ratinggs: [] },
    },
    doc: "createDoc"
  });
}

